import { render } from "./OldViewChildPopup.vue?vue&type=template&id=0d6c6d6c&scoped=true"
import script from "./OldViewChildPopup.vue?vue&type=script&lang=js"
export * from "./OldViewChildPopup.vue?vue&type=script&lang=js"

import "./OldViewChildPopup.vue?vue&type=style&index=0&id=0d6c6d6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6c6d6c"]])

export default __exports__